var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantPauseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.5 21.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 20.8c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.4-10 10 4.5 10 10 10z",
    fill: "#fbbc55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 13.8v-6m5 6v-6m7.6 3c0 5.5-4.5 10-10 10s-10-4.5-10-10 4.4-10 10-10 10 4.5 10 10z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgAiAssistantPauseCircle;